export default __webpack_public_path__ + "static/media/uc.24920557.svg";